




























































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AgencyKBModule } from '@/store/modules/agencyKB';
import { AppModule } from '@/store/modules/app';
import UserProfileMenu from '@/components/Users/UserProfileMenu.vue';
import TOCNavigationNode from '@/components/KnowledgeBase/TOCNavigationNode.vue';
import GiganautVue from '@/components/Shared/GiganautVue';
import TOCSection from '@/models/KnowledgeBase/TOCSection';
import TOCNode from '@/models/KnowledgeBase/TOCNode';
import KBContentListItem from '@/models/KnowledgeBase/KBContentListItem';
import PageNames from '@/router/PageNames';
import KBStatus from '@/models/KnowledgeBase/KBStatus';

// Make PageNames available in template

@Component({
  name: 'KBLayout',
  components: {
    UserProfileMenu,
    TOCNavigationNode
  }
})
export default class extends GiganautVue {
  private searchQuery = '';
  private expandedSections: number[] = [];
  private initializing = true;

  PageNames = PageNames;

  get loadingTOC(): boolean {
    return AgencyKBModule.loadingTOC || this.initializing;
  }

  get tocSections(): TOCSection[] {
    return AgencyKBModule.toc?.published?.structure || [];
  }

  get contentList(): KBContentListItem[] {
    return AgencyKBModule.contentList?.items || [];
  }

  get userType() {
    if (AppModule.userProfile == null) {
      return "";
    }
    return AppModule.userProfile.userType;
  }

  get toolbarColor() {
    if (this.userType === "SysAdmin" && window.location.hostname === "portal.giganaut.com") {
      return "red";
    }
    if (window.location.hostname === "dev-portal.giganaut.com") {
      return "#ff6200";
    }
    if (window.location.hostname === "localhost") {
      return "green";
    }
    return "primary";
  }

  created() {
    this.loadData();
  }

  async loadData() {
    await AgencyKBModule.getTOC();
    await AgencyKBModule.getContentList({ status: KBStatus.Published });
    // Expand all sections by default, but close all folders
    this.expandedSections = this.tocSections.map((_, index) => index);
    this.closeAllFolders();
    // Only hide loading state after initialization is complete
    this.initializing = false;
    // Expand folders for current article if any
    this.expandFoldersForCurrentArticle();
  }

  @Watch('$route')
  onRouteChange() {
    // When navigating to a different article, expand its parent folders
    this.expandFoldersForCurrentArticle();
  }

  expandFoldersForCurrentArticle() {
    // Only run for article pages
    if (this.$route.name !== 'AgencyKBArticle') return;

    const slug = this.$route.params.slug;
    if (!slug) return;

    // Find the content item by slug
    const contentItem = this.contentList.find(c => c.slug === slug);
    if (!contentItem) return;

    // Find and expand all parent folders for this article
    this.findAndExpandArticlePath(contentItem.id);
  }

  findAndExpandArticlePath(contentId: string): boolean {
    // Search through all sections
    for (const section of this.tocSections) {
      if (section.items && this.expandPathToArticle(section.items, contentId)) {
        return true;
      }
    }
    return false;
  }

  expandPathToArticle(nodes: TOCNode[], targetContentId: string): boolean {
    for (const node of nodes) {
      if (node.type === 'article' && node.contentId === targetContentId) {
        // Found the article!
        return true;
      }

      if (node.type === 'folder' && node.items && node.items.length > 0) {
        // Recursively search in child nodes
        if (this.expandPathToArticle(node.items, targetContentId)) {
          // Article found in this branch - expand this folder
          this.$set(node, 'expanded', true);
          return true;
        }
      }
    }
    return false;
  }

  closeAllFolders() {
    // Recursively close all folder nodes
    this.tocSections.forEach(section => {
      if (section.items) {
        this.closeFoldersRecursive(section.items);
      }
    });
  }

  closeFoldersRecursive(nodes: TOCNode[]) {
    nodes.forEach(node => {
      if (node.type === 'folder') {
        this.$set(node, 'expanded', false);
        if (node.items && node.items.length > 0) {
          this.closeFoldersRecursive(node.items);
        }
      }
    });
  }

  getSlugForContent(contentId: string): string {
    const item = this.contentList.find(c => c.id === contentId);
    return item?.slug || contentId;
  }

  performSearch() {
    if (this.searchQuery && this.searchQuery.trim()) {
      // Navigate to KB home with search query
      this.$router.push({
        name: PageNames.AgencyKnowledgeBase,
        query: { q: this.searchQuery }
      });
    }
  }

  clearSearch() {
    this.searchQuery = '';
    AgencyKBModule.clearSearch();
    // Navigate to KB home
    this.$router.push({ name: PageNames.AgencyKnowledgeBase });
  }

  goBack() {
    // Go back to the main app (wherever they came from)
    this.$router.go(-1);
  }

  goToDashboard() {
    // Navigate to Agency Dashboard for all users
    // SysAdmin can then navigate back to SysAdmin level from there
    this.$router.push({ name: PageNames.AgencyDashboard });
  }
}
